import React, { CSSProperties } from 'react';
import { MediaQuery } from '../Common';
import Ratio from 'react-ratio';
import { withTranslation } from 'react-i18next';

const RadioArea = ({ children, onClick }) => {
  return (
    <>
      <MediaQuery min={1000}>
        <Ratio ratio={33 / 26} style={{ ...rootstyle, width: 'calc(33% - 20px)', margin: 10 }} onClick={onClick}>
          {children}
        </Ratio>
      </MediaQuery>
      <MediaQuery max={999}>
        <MediaQuery min={700}>
          <Ratio ratio={33 / 26} style={{ ...rootstyle, width: 'calc(50% - 20px)', margin: 10 }} onClick={onClick}>
            {children}
          </Ratio>
        </MediaQuery>
        <MediaQuery max={699}>
          <Ratio ratio={33 / 26} style={{ ...rootstyle, width: '100%', margin: 10 }} onClick={onClick}>
            {children}
          </Ratio>
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

class StyleThum extends React.Component {
  render() {
    const { t } = this.props;
    const { bg, title, onClick, hasbtn = false, style } = this.props;
    return (
      <>
        <RadioArea
          onClick={() => {
            !hasbtn && onClick && onClick();
          }}
        >
          <div style={{ ...imagestyle, backgroundImage: `url(${bg})` }} />
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div style={{ ...titlestyle, paddingTop: hasbtn ? 24 : 0, ...style }}>{title}</div>
            {hasbtn && (
              <div onClick={onClick} style={{ ...morestyle }}>
                {t('shop_now')}
              </div>
            )}
          </div>
        </RadioArea>
      </>
    );
  }
}

const rootstyle: CSSProperties = {
  textAlign: 'center',
  marginBottom: '1.5vw',
  position: 'relative',
  backgroundColor: 'black',
  cursor: 'pointer',
};

const imagestyle: CSSProperties = {
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  opacity: '0.75',
};

const titlestyle: CSSProperties = {
  fontFamily: 'NSCJKrB',
  color: 'white',
  fontSize: 36,
};

const morestyle: CSSProperties = {
  fontFamily: 'NSCJKrB',
  color: 'black',
  fontSize: 18,
  cursor: 'pointer',
  padding: '10px 60px',
  border: '1px solid black',
  display: 'inline-block',
  backgroundColor: 'white',
  marginTop: 'calc(13%)',
};

export default withTranslation()(StyleThum);
